import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from './PageHero';
import Reveal from './Reveal';

const ComingSoonPage = ({ title, description, image = '/images/HomeSlider11.jpg' }) => (
  <div className="site-page">
    <PageHero eyebrow="Garden of Peace" title={title} description={description} image={image} compact />
    <section className="site-section"><Reveal className="site-container site-container--narrow coming-soon-card"><span><i className="fas fa-seedling" aria-hidden="true" /></span><p className="site-eyebrow">Page status</p><h2>This Page Is Under Construction</h2><p>More information will be added here. If you need help in the meantime, please contact our team directly.</p><Link className="site-button" to="/contactus">Contact us <span aria-hidden="true">→</span></Link></Reveal></section>
  </div>
);

export default ComingSoonPage;
